exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".close-icon[data-v-135aa773]{font-size:30px}", "", {"version":3,"sources":["/home/webuser/salag/releases/35/spa/src/pages/courses/course/Course.scss"],"names":[],"mappings":"AAIA,6BACE,cAAA,CAAA","file":"Course.scss?vue&type=style&index=0&id=135aa773&prod&lang=scss&scoped=true&external","sourcesContent":[".course {\n\n}\n\n.close-icon {\n  font-size: 30px;\n}\n"],"sourceRoot":""}]);

// exports
